import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const navigate = useNavigate();
  
  // Check if already authenticated
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("admin_token");
      if (token) {
        try {
          await axios.get(`${API}/admin/verify`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          navigate("/admin/dashboard");
        } catch {
          localStorage.removeItem("admin_token");
        }
      }
      setIsChecking(false);
    };
    checkAuth();
  }, [navigate]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    
    setIsLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, { password }, { withCredentials: true });
      localStorage.setItem("admin_token", response.data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid password");
    } finally {
      setIsLoading(false);
    }
  };
  
  if (isChecking) {
    return (
      <div className="admin-login">
        <p style={{ color: 'var(--text-secondary)' }}>Checking authentication...</p>
      </div>
    );
  }
  
  return (
    <div className="admin-login" data-testid="admin-login-page">
      <div className="login-form">
        <h1 
          className="text-2xl md:text-3xl font-light tracking-tight mb-8 text-center animate-fade-in-up"
          style={{ fontFamily: 'Manrope, sans-serif', color: 'var(--text-primary)' }}
        >
          Admin Access
        </h1>
        <form onSubmit={handleSubmit} className="space-y-6 animate-fade-in-up animation-delay-200">
          <div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="password-input"
              data-testid="admin-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={!password || isLoading}
            className="btn-primary w-full"
            data-testid="admin-login-btn"
          >
            {isLoading ? "Verifying..." : "Enter"}
          </button>
        </form>
        <p 
          className="text-center mt-8 text-sm animate-fade-in-up animation-delay-300"
          style={{ color: 'var(--text-secondary)' }}
        >
          <a href="/" className="hover:underline">← Back to quiz</a>
        </p>
      </div>
    </div>
  );
}
